const GlobalVar = Object.freeze({
  BASE_DOMAIN:
    !process.env.NODE_ENV || process.env.NODE_ENV === "development"
      ? "http://localhost/meds/brokers/synergyfxtrades.com/apexfx/public"
      : "https://mytradeoptions.com",
});

export default GlobalVar;
